import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

const VUEX_PROPERTIES = ['state', 'getters', 'actions', 'mutations']

let store = {};

(function updateModules () {
  store = normalizeRoot(require('../store/index.js'), 'store/index.js')

  // If store is an exported method = classic mode (deprecated)

  // Enforce store modules
  store.modules = store.modules || {}

  resolveStoreModules(require('../store/catalog/actions.js'), 'catalog/actions.js')
  resolveStoreModules(require('../store/catalog/getters.js'), 'catalog/getters.js')
  resolveStoreModules(require('../store/catalog/mutations.js'), 'catalog/mutations.js')
  resolveStoreModules(require('../store/catalog/state.js'), 'catalog/state.js')
  resolveStoreModules(require('../store/customer/actions.js'), 'customer/actions.js')
  resolveStoreModules(require('../store/customer/mutations.js'), 'customer/mutations.js')
  resolveStoreModules(require('../store/customer/state.js'), 'customer/state.js')
  resolveStoreModules(require('../store/general/actions.js'), 'general/actions.js')
  resolveStoreModules(require('../store/general/mutations.js'), 'general/mutations.js')
  resolveStoreModules(require('../store/general/state.js'), 'general/state.js')
  resolveStoreModules(require('../store/merchants/actions.js'), 'merchants/actions.js')
  resolveStoreModules(require('../store/merchants/mutations.js'), 'merchants/mutations.js')
  resolveStoreModules(require('../store/merchants/state.js'), 'merchants/state.js')
  resolveStoreModules(require('../store/messages/actions.js'), 'messages/actions.js')
  resolveStoreModules(require('../store/messages/mutations.js'), 'messages/mutations.js')
  resolveStoreModules(require('../store/messages/state.js'), 'messages/state.js')
  resolveStoreModules(require('../store/product/actions.js'), 'product/actions.js')
  resolveStoreModules(require('../store/product/mutations.js'), 'product/mutations.js')
  resolveStoreModules(require('../store/product/state.js'), 'product/state.js')
  resolveStoreModules(require('../store/renegotiation/mutations.js'), 'renegotiation/mutations.js')
  resolveStoreModules(require('../store/renegotiation/state.js'), 'renegotiation/state.js')
  resolveStoreModules(require('../store/resubmit/mutations.js'), 'resubmit/mutations.js')
  resolveStoreModules(require('../store/resubmit/state.js'), 'resubmit/state.js')
  resolveStoreModules(require('../store/settings/actions.js'), 'settings/actions.js')
  resolveStoreModules(require('../store/settings/mutations.js'), 'settings/mutations.js')
  resolveStoreModules(require('../store/settings/state.js'), 'settings/state.js')
  resolveStoreModules(require('../store/upload/actions.js'), 'upload/actions.js')
  resolveStoreModules(require('../store/upload/mutations.js'), 'upload/mutations.js')
  resolveStoreModules(require('../store/upload/state.js'), 'upload/state.js')
  resolveStoreModules(require('../store/useractionlog/actions.js'), 'useractionlog/actions.js')

  // If the environment supports hot reloading...
})()

// createStore
export const createStore = store instanceof Function ? store : () => {
  return new Vuex.Store(Object.assign({
    strict: (process.env.NODE_ENV !== 'production')
  }, store))
}

function normalizeRoot (moduleData, filePath) {
  moduleData = moduleData.default || moduleData

  if (moduleData.commit) {
    throw new Error(`[nuxt] ${filePath} should export a method that returns a Vuex instance.`)
  }

  if (typeof moduleData !== 'function') {
    // Avoid TypeError: setting a property that has only a getter when overwriting top level keys
    moduleData = Object.assign({}, moduleData)
  }
  return normalizeModule(moduleData, filePath)
}

function normalizeModule (moduleData, filePath) {
  if (moduleData.state && typeof moduleData.state !== 'function') {
    console.warn(`'state' should be a method that returns an object in ${filePath}`)

    const state = Object.assign({}, moduleData.state)
    // Avoid TypeError: setting a property that has only a getter when overwriting top level keys
    moduleData = Object.assign({}, moduleData, { state: () => state })
  }
  return moduleData
}

function resolveStoreModules (moduleData, filename) {
  moduleData = moduleData.default || moduleData
  // Remove store src + extension (./foo/index.js -> foo/index)
  const namespace = filename.replace(/\.(js|mjs)$/, '')
  const namespaces = namespace.split('/')
  let moduleName = namespaces[namespaces.length - 1]
  const filePath = `store/${filename}`

  moduleData = moduleName === 'state'
    ? normalizeState(moduleData, filePath)
    : normalizeModule(moduleData, filePath)

  // If src is a known Vuex property
  if (VUEX_PROPERTIES.includes(moduleName)) {
    const property = moduleName
    const propertyStoreModule = getStoreModule(store, namespaces, { isProperty: true })

    // Replace state since it's a function
    mergeProperty(propertyStoreModule, moduleData, property)
    return
  }

  // If file is foo/index.js, it should be saved as foo
  const isIndexModule = (moduleName === 'index')
  if (isIndexModule) {
    namespaces.pop()
    moduleName = namespaces[namespaces.length - 1]
  }

  const storeModule = getStoreModule(store, namespaces)

  for (const property of VUEX_PROPERTIES) {
    mergeProperty(storeModule, moduleData[property], property)
  }

  if (moduleData.namespaced === false) {
    delete storeModule.namespaced
  }
}

function normalizeState (moduleData, filePath) {
  if (typeof moduleData !== 'function') {
    console.warn(`${filePath} should export a method that returns an object`)
    const state = Object.assign({}, moduleData)
    return () => state
  }
  return normalizeModule(moduleData, filePath)
}

function getStoreModule (storeModule, namespaces, { isProperty = false } = {}) {
  // If ./mutations.js
  if (!namespaces.length || (isProperty && namespaces.length === 1)) {
    return storeModule
  }

  const namespace = namespaces.shift()

  storeModule.modules[namespace] = storeModule.modules[namespace] || {}
  storeModule.modules[namespace].namespaced = true
  storeModule.modules[namespace].modules = storeModule.modules[namespace].modules || {}

  return getStoreModule(storeModule.modules[namespace], namespaces, { isProperty })
}

function mergeProperty (storeModule, moduleData, property) {
  if (!moduleData) {
    return
  }

  if (property === 'state') {
    storeModule.state = moduleData || storeModule.state
  } else {
    storeModule[property] = Object.assign({}, storeModule[property], moduleData)
  }
}
